<div class="gc-send-notification-container">
  <form class="p-form" [formGroup]="petitionAuditLogForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="form-group col-3">
        <label class="p-label required">To</label>
        <p-dropdown placeholder="Select" class="p-form-control" [options]="recipientList" optionValue="id"
          optionLabel="name" formControlName="to" (onChange)="onRecipientChange()">
        </p-dropdown>
        <small
          *ngIf="!petitionAuditLogForm.get('to').valid && petitionAuditLogForm.get('to').touched && petitionAuditLogForm.get('to').errors"
          class="p-error">
          <span *ngIf="petitionAuditLogForm.get('to').errors['required']">Recipient is required.</span>
        </small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <textarea [rows]="3" formControlName="message" class="p-form-control" pInputTextarea
          autoResize="autoResize"></textarea>
        <small
          *ngIf="!petitionAuditLogForm.get('message').valid && petitionAuditLogForm.get('message').touched && petitionAuditLogForm.get('message').errors"
          class="p-error">
          <span *ngIf="petitionAuditLogForm.get('message').errors['required']">Message is required.</span>
        </small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 text-right">
        <button type="button" class="p-btn btn btn-light mr-3" (click)="onClose()">CANCEL</button>
        <button type="submit" [disabled]="petitionAuditLogForm.invalid"
          [ngClass]="{'disabled': petitionAuditLogForm.invalid}" class="p-btn btn btn-primary">SEND</button>
      </div>
    </div>
  </form>
</div>
